__turbopack_context__.v({
  "head": "eVGs4W_head",
  "items": "eVGs4W_items",
  "root": "eVGs4W_root",
  "sleepItemsContainer": "eVGs4W_sleepItemsContainer",
});
